import React, { useEffect } from 'react';
import styles from './VersionDisplay.module.css';

const VersionDisplay = () => {
    // These constants are injected by Vite at build time
    // Use try/catch or typeof check to avoid crashing if not defined (e.g. in test env)
    let version = 'dev';
    let rawDate = 'unknown';
    try {
        /* eslint-disable no-undef */
        if (typeof __APP_VERSION__ !== 'undefined') version = __APP_VERSION__;
        if (typeof __BUILD_DATE__ !== 'undefined') rawDate = __BUILD_DATE__;
        /* eslint-enable no-undef */
    } catch (e) { }

    // Format date for display
    let displayDate = rawDate;
    try {
        const d = new Date(rawDate);
        if (!isNaN(d.getTime())) {
            displayDate = d.toISOString().split('T')[0]; // YYYY-MM-DD
        }
    } catch (e) { }

    useEffect(() => {
        // Verbose logging as requested
        console.log(
            `%c Red Green Tampere %c v${version} %c ${rawDate} `,
            'background:#e02e2e; color:white; padding: 2px 4px; border-radius: 3px 0 0 3px; font-weight: bold;',
            'background:#22c55e; color:white; padding: 2px 4px; font-weight: bold;',
            'background:#555; color:white; padding: 2px 4px; border-radius: 0 3px 3px 0;'
        );
    }, [version, rawDate]);

    return (
        <div className={styles.Display}>
            {version} ({displayDate})
        </div>
    );
};

export default VersionDisplay;
